import gatewayService from '@/modules/common/services/gatewayService';
import logError from '@/utils/logError/logError';

const baseRoute = 'v3/access_control';

const getStaffPermissions = async (keys) => {
  if (!Array.isArray(keys) || keys.length === 0) {
    throw new Error('Keys must be a non-empty array');
  }

  try {
    const response = await gatewayService.get(`${baseRoute}/staff_permissions`, { keys });
    return response.data.data.staff_permissions;
  } catch (error) {
    logError('Error fetching staff permissions:', error, { keys });
    throw error;
  }
};

export default {
  getStaffPermissions,
};
